import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CourseRelatedSubject } from '../../models/course-search.models';
import { CourseSearchNoResultComponent } from '../course-search-no-result/course-search-no-result.component';
import { BackToAllCoursesBtnComponent } from '../back-to-all-courses-btn/back-to-all-courses-btn.component';
import { SubjectsCarouselComponent } from '../subjects-carousel/subjects-carousel.component';
import { RelatedSubjectComponent } from '../related-subject/related-subject.component';
import { Product } from '@uc/web/shared/data-models';
import { InfoClearingToggleComponent } from '@web/shared/ui';
import { INFO_CLEARING_TOGGLE } from '../../static/clearing-course-search.properties';
import { NgClass } from '@angular/common';
import { CLEARING_ENABLED } from '@uc/web/config';

@Component({
	selector: 'uc-course-search-result',
	templateUrl: './course-search-result.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		CourseSearchNoResultComponent,
		BackToAllCoursesBtnComponent,
		SubjectsCarouselComponent,
		RelatedSubjectComponent,
		InfoClearingToggleComponent,
		NgClass,
	],
})
export class CourseSearchResultComponent {
	resultLength = input.required<number | undefined>();
	product = input.required<Product>();
	degreeLevel = input<string>();
	showIndividualUniCourses = input.required<boolean>();
	relatedSubjects = input<CourseRelatedSubject[]>();

	studyLevelChange = output<string>();
	relatedSubject = output<string>();

	readonly infoClearingToggle = INFO_CLEARING_TOGGLE;

	onRelatedSubject(subject: string) {
		this.relatedSubject.emit(subject);
	}

	clearingEnabled = CLEARING_ENABLED;
}
